export default "__VITE_ASSET__BWry8DGu__"